import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/ElectricityCheckoutDataProvider";
import Checkbox from "../../../../shared/forms/Checkbox";
import Headline from "../../../../shared/NewHeadline";
import OrderChoiceButtons from "../../../../shared/OrderChoiceButtons";
import DifferentAccountHolder from "./DifferentAccountHolder";
import RemittancePayment from "./RemittancePayment";
import SepaPayment from "./SepaPayment";

const StepPaymentType = () => {
    const dataContext = useContext(DataContext);
    const { paymentTypes, paymentData } = dataContext.data;
    const { paymentTypeHasChanged, setPaymentData, setFormErrors } =
        dataContext.actions;
    const hasAdditions =
        paymentTypes.filter((paymentType) => paymentType.addition > 0).length >
        0;

    const onChangePaymentType = (value) => {
        setPaymentData({
            ...paymentData,
            ...{ payment_payment_type: value },
        });
        paymentTypeHasChanged();
        setFormErrors([]);
    };

    const handleInvoiceCheckboxChange = () => {
        setPaymentData({
            ...paymentData,
            ...{
                payment_different_account_holder:
                    !paymentData.payment_different_account_holder,
            },
        });
        setFormErrors([]);
    };

    return (
        <section>
            <Headline>Zahlart</Headline>
            <OrderChoiceButtons
                choices={paymentTypes}
                activeId={paymentData.payment_payment_type}
                onChoiceChange={onChangePaymentType}
                hasSubtitle={hasAdditions}
            />
            <SepaPayment />
            <RemittancePayment />

            <section>
                <React.Fragment>
                    <Checkbox
                        checked={paymentData.payment_different_account_holder}
                        onClick={handleInvoiceCheckboxChange}
                        label="Abweichender Kontoinhaber"
                    />
                </React.Fragment>
            </section>
            {paymentData.payment_different_account_holder === true && (
                <DifferentAccountHolder />
            )}
        </section>
    );
};

export default StepPaymentType;
